module.exports = __webpack_public_path__ + "media/images/links_to_banks_on_success_page/Vietcombank-42358edc4711dfddf08ae61a036401bc.png";